import { ANALYTICS_EVENTS, pushEvent } from './analytics';

const RETRY_DELAYS_MS = [400, 1200];
const abortError = () => new DOMException('Request aborted', 'AbortError');

const waitForRetry = (delay, signal) =>
  new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(abortError());
      return;
    }
    const onAbort = () => {
      clearTimeout(timer);
      reject(abortError());
    };
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort);
      resolve();
    }, delay);
    signal?.addEventListener('abort', onAbort, { once: true });
  });

// Only catalog reads are safe to retry here; checkout mutations never use this helper.
export const retryCatalogRequest = async (
  read,
  { signal, surface, promoCodePresent = false, reportFailure = true, delays = RETRY_DELAYS_MS },
) => {
  for (let attempts = 1; ; attempts += 1) {
    if (signal?.aborted) throw abortError();
    try {
      const data = await read();
      if (signal?.aborted) throw abortError();
      return data;
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      if (signal?.aborted) throw abortError();
      const status = error?.status || 0;
      const reason = status ? 'http' : error?.name === 'TimeoutError' ? 'timeout' : 'network';
      const transient = status
        ? status === 429 || (status >= 500 && status < 600)
        : error instanceof TypeError || error?.name === 'TimeoutError' || error?.status === 0;
      if (transient && attempts <= RETRY_DELAYS_MS.length) {
        await waitForRetry(delays[attempts - 1] ?? RETRY_DELAYS_MS[attempts - 1], signal);
        continue;
      }
      if (reportFailure) {
        pushEvent({
          event: ANALYTICS_EVENTS.PRICING_CATALOG_LOAD_FAILED,
          surface,
          attempts,
          status,
          reason,
          promo_code_present: promoCodePresent,
          source: window.location.pathname,
        });
      }
      throw error;
    }
  }
};
